/* TOXIC by Tendenciez — Theme JS */

// ─── START AT THE TOP ──────────────────────────────────
// Mobile browsers reopen/reload pages at the old scroll position, which hides the
// first heading under the fixed header. Keep restoration only for Back/Forward.
// iOS Safari can re-apply the old position after load, so keep resetting until the
// visitor touches or scrolls the page themselves.
(() => {
  const nav = performance.getEntriesByType?.('navigation')[0];
  if (!nav || nav.type === 'back_forward' || location.hash) return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  let userActed = false;
  ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach(ev =>
    window.addEventListener(ev, () => { userActed = true; }, { once: true, passive: true }));
  const toTop = () => { if (!userActed && window.scrollY !== 0) window.scrollTo(0, 0); };
  toTop();
  requestAnimationFrame(toTop);
  window.addEventListener('load', () => { toTop(); setTimeout(toTop, 250); setTimeout(toTop, 800); }, { once: true });
  window.addEventListener('pageshow', toTop, { once: true });
})();
window.addEventListener('pagehide', () => { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; });

// ─── HEADER SCROLL ─────────────────────────────────────
const header = document.querySelector('.site-header');
if (header) {
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ─── MOBILE MENU ───────────────────────────────────────
const mobileMenu = document.querySelector('.mobile-menu');
const btnOpen    = document.querySelector('.btn-menu');
const btnClose   = document.querySelector('.btn-menu-close');

// Lock page scroll while the menu or cart is open
const syncScrollLock = () => {
  const open = mobileMenu?.classList.contains('open') || document.querySelector('.cart-drawer')?.classList.contains('open');
  document.documentElement.classList.toggle('is-locked', !!open);
};

function openMenu()  { mobileMenu?.classList.add('open'); btnOpen?.setAttribute('aria-expanded', 'true'); syncScrollLock(); }
function closeMenu() { mobileMenu?.classList.remove('open'); btnOpen?.setAttribute('aria-expanded', 'false'); syncScrollLock(); }

btnOpen?.addEventListener('click', openMenu);
btnClose?.addEventListener('click', closeMenu);
mobileMenu?.querySelectorAll('.mobile-menu__links a').forEach(a => a.addEventListener('click', closeMenu));

// ─── CART DRAWER ───────────────────────────────────────
const cartDrawer  = document.querySelector('.cart-drawer');
const cartOverlay = document.querySelector('.cart-overlay');
const btnCarts    = document.querySelectorAll('[data-open-cart]');
const btnCloseCart = document.querySelector('[data-close-cart]');

function openCart()  { closeMenu(); cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); syncScrollLock(); }
function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); syncScrollLock(); }

btnCarts.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
cartOverlay?.addEventListener('click', closeCart);
btnCloseCart?.addEventListener('click', closeCart);
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { closeCart(); closeMenu(); }
});

// ─── SUPPORT EMAIL ─────────────────────────────────────
document.querySelectorAll('.footer__email-link').forEach(link => {
  link.addEventListener('click', e => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia('(pointer: coarse)').matches;
    if (!isMobile) {
      e.preventDefault();
      const email = link.dataset.email;
      navigator.clipboard.writeText(email).then(() => {
        const copied = link.nextElementSibling;
        if (copied) {
          copied.classList.add('visible');
          setTimeout(() => copied.classList.remove('visible'), 2000);
        }
      });
    }
  });
});

// ─── ACTIVE NAV ────────────────────────────────────────
document.querySelectorAll('.nav-links a, .mobile-menu__links a').forEach(link => {
  if (link.getAttribute('href') === window.location.pathname) {
    link.classList.add('active');
  }
});

// ─── VARIANT SELECTOR ──────────────────────────────────
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-btns');
    group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const input = document.querySelector('input[name="id"]');
    if (input) input.value = btn.dataset.variantId;
  });
});

// ─── ADD TO CART ───────────────────────────────────────
const addToCartForm = document.querySelector('.add-to-cart-form');
const cartCountEls  = document.querySelectorAll('.cart-count');

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    cartCountEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'grid' : 'none';
    });
    renderCartItems(cart);
  } catch (e) { console.error(e); }
}

const escapeHtml = (str) => String(str ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function formatMoney(cents, currency) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
  } catch (e) {
    return '$' + (cents / 100).toFixed(2);
  }
}

function sizedImage(url, width) {
  if (!url) return '';
  return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
}

async function renderCartItems(cart) {
  const body = document.querySelector('.cart-drawer__body');
  const total = document.querySelector('.cart-drawer__total-amount');
  if (!body) return;

  if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
  cartDrawer?.classList.toggle('is-empty', cart.item_count === 0);

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    return;
  }

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}">
      <a href="${escapeHtml(item.url)}">
        ${item.image ? `<img class="cart-item__img" src="${escapeHtml(sizedImage(item.image, 180))}" alt="${escapeHtml(item.product_title)}" width="72" height="90" loading="lazy">` : ''}
      </a>
      <div>
        <p class="cart-item__name">${escapeHtml(item.product_title)}</p>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
        <div class="cart-item__qty">
          <button type="button" data-qty-step="-1" aria-label="Decrease quantity">&minus;</button>
          <span aria-live="polite">${item.quantity}</span>
          <button type="button" data-qty-step="1" aria-label="Increase quantity">+</button>
        </div>
      </div>
      <div class="cart-item__side">
        <p class="cart-item__price">${formatMoney(item.final_line_price, cart.currency)}</p>
        <button type="button" class="cart-item__remove" data-remove>Remove</button>
      </div>
    </div>
  `).join('');
}

async function changeCartLine(key, quantity) {
  const body = document.querySelector('.cart-drawer__body');
  body?.classList.add('is-busy');
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error('Cart update failed');
    await updateCartCount();
  } catch (e) {
    console.error(e);
  } finally {
    body?.classList.remove('is-busy');
  }
}

document.querySelector('.cart-drawer__body')?.addEventListener('click', (e) => {
  const line = e.target.closest('.cart-item');
  if (!line) return;
  const qty = Number(line.dataset.qty);
  const step = e.target.closest('[data-qty-step]');
  if (step) changeCartLine(line.dataset.key, Math.max(0, qty + Number(step.dataset.qtyStep)));
  if (e.target.closest('[data-remove]')) changeCartLine(line.dataset.key, 0);
});

addToCartForm?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const btn = addToCartForm.querySelector('.btn-add-to-cart');
  const error = addToCartForm.querySelector('.add-to-cart-form__error');
  if (btn?.disabled) return;
  if (btn) btn.disabled = true;
  if (error) error.textContent = '';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(addToCartForm),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || 'Could not add to cart. Please try again.');
    }
    await updateCartCount();
    openCart();
  } catch (err) {
    if (error) error.textContent = err.message;
  } finally {
    if (btn) btn.disabled = false;
  }
});

updateCartCount();

// ─── PRODUCT CARD SWIPE GALLERIES (site-wide) ──────────
function initProductGalleries() {
  document.querySelectorAll('.product-card__gallery').forEach((g) => {
    if (g.dataset.galleryInit) return;          // guard against double-binding
    const slides = g.querySelectorAll('.product-card__slide');
    if (slides.length < 2) { g.dataset.galleryInit = '1'; return; }
    g.dataset.galleryInit = '1';

    const dots = document.createElement('div');
    dots.className = 'product-card__dots';
    slides.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'product-card__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    g.parentNode.appendChild(dots);

    let ticking = false;
    g.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const idx = Math.round(g.scrollLeft / g.clientWidth);
        dots.querySelectorAll('.product-card__dot').forEach((d, i) => {
          d.classList.toggle('is-active', i === idx);
        });
        ticking = false;
      });
    }, { passive: true });
  });
}
initProductGalleries();

// ─── PRODUCT PAGE GALLERY ──────────────────────────────
document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('.product-gallery__track');
  const dots = gallery.querySelectorAll('.product-gallery__dot');
  const prev = gallery.querySelector('.product-gallery__arrow--prev');
  const next = gallery.querySelector('.product-gallery__arrow--next');
  const count = track.children.length;
  if (count < 2) return;

  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  const goTo = (i) => {
    const idx = Math.max(0, Math.min(count - 1, i));
    track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
  };
  const update = () => {
    const idx = current();
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === count - 1;
  };

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => { update(); ticking = false; });
  }, { passive: true });

  dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
  prev?.addEventListener('click', () => goTo(current() - 1));
  next?.addEventListener('click', () => goTo(current() + 1));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
  });
  update();
});
